import axios from 'axios';
import { API_PATH } from '../../../constants';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPIActions from '../../utils/api-metadata-actions';

const options = {
  name: 'certifications',
  baseType: 'CERTIFICATIONS',
  apiEndpoint: 'certifications'
};

const defaultOperations = createMetadataAPIOperations(options);
const actions = createMetadataAPIActions(options);

//This is for making the API call to update the skills that a membership has
//when the skill checkbox is clicked
const assignSkill = (membershipId, skillId, possessed) => dispatch => {
  const data = { possessed, skill_id: skillId };
  return axios
    .post(`${API_PATH}/memberships/${membershipId}/certifications`, data)
    .then(response => dispatch(actions.fetchSuccessful(response.data, { replace: true })));
};

export default {
  ...defaultOperations,
  assignSkill
};
